module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-regular-400-ece54318791c51b52dfdc689efdb6271.ttf";